export const imageUrl = "https://test.tdtu.uz/storage/";